<div class="background-body">
  <div class="container auth-logo-card-spacing align-items-center d-flex min-vh-100 py-4">
    <div class="logo-section me-auto">
      <img :src="styleConfig.login_page_logo" alt="aicone Logo" class="logo">
      <div class="user-count d-none">
        <div class="user-dots d-flex">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <span>3k+ people joined us, now it's your turn</span>
      </div>
    </div>

    <div class="sign-in-form">
      <div class="mb-1 text-start">
        <h2 class="text-black fw-bold">Set New Password</h2>
        <p class="text-muted small mb-4 mt-2">For security, please create a new password to continue.</p>
      </div>

      <form @submit.prevent="submit_form" id="first_time_reset_form" novalidate>
        <!-- New Password -->
        <div class="form-floating-custom password-group">
          <input :type="password_visible ? 'text' : 'password'" id="new_password" class="form-input" placeholder=" "
            v-model.trim="form.new_password" autocomplete="new-password" required minlength="8" />
          <label class="form-label" for="new_password">New Password</label>
          <button type="button" class="password-toggle" @click="toggle_password_visibility('password')">
            <i :class="password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </div>

        <!-- Confirm Password -->
        <div class="form-floating-custom password-group">
          <input :type="confirm_password_visible ? 'text' : 'password'" id="confirm_password" class="form-input"
            placeholder=" " v-model.trim="form.confirm_password" autocomplete="new-password" required minlength="8" />
          <label class="form-label" for="confirm_password">Confirm Password</label>
          <button type="button" class="password-toggle" @click="toggle_password_visibility('confirm')">
            <i :class="confirm_password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </div>
        <div class="password-criteria mt-1 mb-2 text-start small">
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.length, 'fa fa-check-circle': !meets_criteria.length }"
              class="me-1"></i> At least 8 characters
          </div>
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.lowercase, 'fa fa-check-circle': !meets_criteria.lowercase }"
              class="me-1"></i> Lowercase letter
          </div>
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.uppercase, 'fa fa-check-circle': !meets_criteria.uppercase }"
              class="me-1"></i> Uppercase letter
          </div>
          <div class="criteria-item">
            <i :class="{ 'fa fa-check-circle text-success': meets_criteria.special, 'fa fa-check-circle': !meets_criteria.special }"
              class="me-1"></i> Special character
          </div>
        </div>
        <!-- Submit -->
        <button type="submit" class="sign-up-btn" :disabled="loading">
          <span v-if="!loading">Update Password</span>
          <span v-else>
            <i class="bi bi-arrow-repeat spin"></i> Updating...
          </span>
        </button>
      </form>
    </div>
  </div>
</div>
<!-- Powered By Footer -->
<div class="position-fixed bottom-0 start-50 translate-middle-x small text-white pb-3">
  © {{ current_year }} Powered by <span class="fw-bold">{{ powered_by_name }}</span>
</div>